import {type CSSProperties, useCallback, useMemo, useRef} from "react";
import {autoUpdate, type Middleware, offset, type ReferenceType, size, useFloating} from "@floating-ui/react";

import type {IUseAnchoredPanelOptions, IUseAnchoredPanelResult} from "../types/IUseAnchoredPanelOptions";
import {useIsomorphicLayoutEffect} from "./use_isomorphic_layout_effect";

const PANEL_MAX_HEIGHT_VARIABLE = "--search-combobox-panel-max-height";
const PANEL_SIZE_MIDDLEWARE = "searchComboboxPanelSize";

interface IPanelSizeData {
    availableHeight: number;
    anchorWidth: number;
    viewportHeight: number;
}

/**
 * `size` measures the room below the anchor, but applying it inside `apply` would mean either DOM writes behind
 * React's back or a `setState` of our own on every scroll. Instead the measurement is returned as middleware data, so
 * it lands in the same state update floating-ui already makes for the new position.
 */
const panelSize = (viewportPadding: number): Middleware => ({
    name: PANEL_SIZE_MIDDLEWARE,
    options: {viewportPadding},
    async fn(state) {
        let data: IPanelSizeData | undefined;

        await size({
            padding: viewportPadding,
            apply: ({availableHeight, rects}) => {
                data = {availableHeight, anchorWidth: rects.reference.width, viewportHeight: window.innerHeight};
            }
        }).fn(state);

        return {data};
    }
});

// jsdom (unit tests) has no IntersectionObserver; skip the observers the environment cannot provide.
const autoUpdateWhileOpen = (reference: ReferenceType, floating: HTMLElement, update: () => void) =>
    autoUpdate(reference, floating, update, {
        elementResize: typeof ResizeObserver === "function",
        layoutShift: typeof IntersectionObserver === "function"
    });

/**
 * Positions a panel under an anchor element: same width as the anchor, `gap` px below it, never flipped upwards (the
 * search sits at the top of the page). The panel height is capped at `min(maxHeightVh, room below − viewportPadding)`
 * but never below `minHeight` - past that point the page scrolls. The cap is exposed as the
 * `--search-combobox-panel-max-height` variable in `panelStyle`. Positions update with `autoUpdate` while open.
 */
export const useAnchoredPanel = (options: IUseAnchoredPanelOptions): IUseAnchoredPanelResult => {
    const {anchorRef, isOpen, gap = 10, maxHeightVh = 70, viewportPadding = 16, minHeight = 240, mode = "portal", zIndex = 1100} = options;
    const panelRef = useRef<HTMLElement | null>(null);

    const {refs, floatingStyles, middlewareData, isPositioned} = useFloating({
        open: isOpen,
        placement: "bottom-start",
        strategy: mode === "portal" ? "fixed" : "absolute",
        middleware: [offset(gap), panelSize(viewportPadding)],
        whileElementsMounted: isOpen ? autoUpdateWhileOpen : undefined
    });

    // The anchor is owned by the consumer; hand it over whenever the panel opens (it may have been re-mounted meanwhile).
    useIsomorphicLayoutEffect(() => {
        refs.setReference(anchorRef.current);
    }, [anchorRef, isOpen, refs]);

    const setPanelElement = useCallback(
        (element: HTMLElement | null) => {
            panelRef.current = element;
            refs.setFloating(element);
        },
        [refs]
    );

    const sizeData = middlewareData[PANEL_SIZE_MIDDLEWARE] as IPanelSizeData | undefined;

    const panelStyle = useMemo((): CSSProperties => {
        const style: CSSProperties & Record<string, string | number | undefined> = {...floatingStyles, zIndex};

        if (sizeData) {
            const heightCap = (sizeData.viewportHeight * maxHeightVh) / 100;
            const maxHeight = Math.max(minHeight, Math.min(heightCap, sizeData.availableHeight));

            style.width = sizeData.anchorWidth;
            style[PANEL_MAX_HEIGHT_VARIABLE] = `${Math.floor(maxHeight)}px`;
        }

        return style;
    }, [floatingStyles, zIndex, sizeData, maxHeightVh, minHeight]);

    return {setPanelElement, panelRef, panelStyle, isPositioned, mode};
};
import {type CSSProperties, useCallback, useMemo, useRef} from "react";
import {autoUpdate, type Middleware, offset, type ReferenceType, size, useFloating} from "@floating-ui/react";

import type {IUseAnchoredPanelOptions, IUseAnchoredPanelResult} from "../types/IUseAnchoredPanelOptions";
import {useIsomorphicLayoutEffect} from "./use_isomorphic_layout_effect";

const PANEL_MAX_HEIGHT_VARIABLE = "--search-combobox-panel-max-height";
const PANEL_SIZE_MIDDLEWARE = "searchComboboxPanelSize";

interface IPanelSizeData {
    availableHeight: number;
    anchorWidth: number;
    viewportHeight: number;
}

/**
 * `size` measures the room below the anchor, but applying it inside `apply` would mean either DOM writes behind
 * React's back or a `setState` of our own on every scroll. Instead the measurement is returned as middleware data, so
 * it lands in the same state update floating-ui already makes for the new position.
 */
const panelSize = (viewportPadding: number): Middleware => ({
    name: PANEL_SIZE_MIDDLEWARE,
    options: {viewportPadding},
    async fn(state) {
        let data: IPanelSizeData | undefined;

        await size({
            padding: viewportPadding,
            apply: ({availableHeight, rects}) => {
                data = {availableHeight, anchorWidth: rects.reference.width, viewportHeight: window.innerHeight};
            }
        }).fn(state);

        return {data};
    }
});

// jsdom (unit tests) has no IntersectionObserver; skip the observers the environment cannot provide.
const autoUpdateWhileOpen = (reference: ReferenceType, floating: HTMLElement, update: () => void) =>
    autoUpdate(reference, floating, update, {
        elementResize: typeof ResizeObserver === "function",
        layoutShift: typeof IntersectionObserver === "function"
    });

/**
 * Positions a panel under an anchor element: same width as the anchor, `gap` px below it, never flipped upwards (the
 * search sits at the top of the page). The panel height is capped at `min(maxHeightVh, room below − viewportPadding)`
 * but never below `minHeight` - past that point the page scrolls. The cap is exposed as the
 * `--search-combobox-panel-max-height` variable in `panelStyle`. Positions update with `autoUpdate` while open.
 */
export const useAnchoredPanel = (options: IUseAnchoredPanelOptions): IUseAnchoredPanelResult => {
    const {anchorRef, isOpen, gap = 10, maxHeightVh = 70, viewportPadding = 16, minHeight = 240, mode = "portal", zIndex = 1100} = options;
    const panelRef = useRef<HTMLElement | null>(null);

    const {refs, floatingStyles, middlewareData, isPositioned} = useFloating({
        open: isOpen,
        placement: "bottom-start",
        strategy: mode === "portal" ? "fixed" : "absolute",
        middleware: [offset(gap), panelSize(viewportPadding)],
        whileElementsMounted: isOpen ? autoUpdateWhileOpen : undefined
    });

    // The anchor is owned by the consumer; hand it over whenever the panel opens (it may have been re-mounted meanwhile).
    useIsomorphicLayoutEffect(() => {
        refs.setReference(anchorRef.current);
    }, [anchorRef, isOpen, refs]);

    const setPanelElement = useCallback(
        (element: HTMLElement | null) => {
            panelRef.current = element;
            refs.setFloating(element);
        },
        [refs]
    );

    const sizeData = middlewareData[PANEL_SIZE_MIDDLEWARE] as IPanelSizeData | undefined;

    const panelStyle = useMemo((): CSSProperties => {
        const style: CSSProperties & Record<string, string | number | undefined> = {...floatingStyles, zIndex};

        if (sizeData) {
            const heightCap = (sizeData.viewportHeight * maxHeightVh) / 100;
            const maxHeight = Math.max(minHeight, Math.min(heightCap, sizeData.availableHeight));

            style.width = sizeData.anchorWidth;
            style[PANEL_MAX_HEIGHT_VARIABLE] = `${Math.floor(maxHeight)}px`;
        }

        return style;
    }, [floatingStyles, zIndex, sizeData, maxHeightVh, minHeight]);

    return {setPanelElement, panelRef, panelStyle, isPositioned, mode};
};
